module.exports = __webpack_public_path__ + "static/img/empty.b3edf69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty.png
// module id = Bm30
// module chunks = 171